import React from 'react';
import './LayoutSelector.css';

const heroHeaderLayouts = [
    {
        id: 'classic-split',
        name: 'Classic Split',
        description: '50/50 Text & Image',
        preview: '▐▌',
        icon: '/img/layouts/classic-split.svg',
        config: {
            textFlex: '1',
            imageFlex: '1',
            direction: 'row',
            textAlign: 'left',
            imagePosition: 'right',
            overlayMode: false,
            mobileStack: true
        }
    },
    {
        id: 'full-width-overlay',
        name: 'Full Width Overlay',
        description: 'Text over background',
        preview: '▓▓▓',
        icon: '/img/layouts/full-width.svg',
        config: {
            textFlex: '1',
            imageFlex: '0',
            direction: 'column',
            textAlign: 'center',
            imagePosition: 'background',
            overlayMode: true,
            mobileStack: false
        }
    },
    {
        id: 'classic-minimal',
        name: 'Classic Minimal',
        description: 'Title + Description + Button',
        preview: '▐▌',
        icon: '/img/layouts/classic-split.svg',
        config: {
            textFlex: '1',
            imageFlex: '1',
            direction: 'row',
            textAlign: 'left',
            imagePosition: 'right',
            overlayMode: false,
            mobileStack: true,
            hideSubtitle: true,
            hideAdditional: true,
            descriptionAfterTitle: true
        }
    },
    {
        id: 'minimalistic',
        name: 'Minimalistic',
        description: 'Small text + Round button + 65% image',
        preview: '▌▐▐',
        icon: '/img/layouts/classic-split.svg',
        config: {
            textFlex: '1',
            imageFlex: '1',
            direction: 'row',
            textAlign: 'left',
            imagePosition: 'right',
            overlayMode: false,
            mobileStack: true,
            smallerText: true,
            roundButton: true,
            defaultImageWidth: 60
        }
    }
];

const hiWidgetLayouts = [
    {
        id: 'classic-profile',
        name: 'Classic Profile',
        description: 'Image left, text right',
        preview: '●▐',
        config: {
            direction: 'row',
            textAlign: 'left',
            imageSize: 'normal'
        }
    },
    {
        id: 'image-focus',
        name: 'Image Focus',
        description: 'Large image focus',
        preview: '●●▐',
        config: {
            direction: 'row',
            textAlign: 'left',
            imageSize: 'large'
        }
    },
    {
        id: 'centered-profile',
        name: 'Centered Profile',
        description: 'Image top, text bottom',
        preview: '●\n▐',
        config: {
            direction: 'column',
            textAlign: 'center',
            imageSize: 'normal'
        }
    },
    {
        id: 'reverse-profile',
        name: 'Reverse Profile',
        description: 'Text left, image right',
        preview: '▐●',
        config: {
            direction: 'row-reverse',
            textAlign: 'right',
            imageSize: 'normal'
        }
    },
    {
        id: 'text-only-center',
        name: 'Text Only Center',
        description: 'Centered text & button',
        preview: '▐▐▐',
        config: {
            direction: 'column',
            textAlign: 'center',
            imageSize: 'hidden',
            showImage: false
        }
    },
    {
        id: 'full-height-left',
        name: 'Full Height Left',
        description: 'Full height image left',
        preview: '█▐',
        config: {
            direction: 'row',
            textAlign: 'left',
            imageSize: 'fullHeight',
            showImage: true,
            imageMode: 'fullHeight'
        }
    },
    {
        id: 'full-height-right',
        name: 'Full Height Right',
        description: 'Full height image right',
        preview: '▐█',
        config: {
            direction: 'row-reverse',
            textAlign: 'right',
            imageSize: 'fullHeight',
            showImage: true,
            imageMode: 'fullHeight'
        }
    },
];


const simplicisticTestimonialLayouts = [
    {
        id: 'classic-grid',
        name: 'Classic Grid',
        description: 'Elegant card grid with premium styling',
        preview: '□□\n□□',
        config: {
            testimonialLayout: 'classic-grid'
        }
    },
    {
        id: 'paper-cards',
        name: 'Paper Cards',
        description: 'Vintage paper with torn edges',
        preview: '📄📄\n📄📄',
        config: {
            testimonialLayout: 'paper-cards'
        }
    },
    // Full-Width Layouts
    {
        id: 'full-width-classic',
        name: 'Full Width Classic',
        description: 'Clean full-width testimonials stacked vertically',
        preview: '●━━━━━━━━━\n●━━━━━━━━━\n●━━━━━━━━━',
        config: {
            testimonialLayout: 'full-width-classic'
        }
    },
    {
        id: 'full-width-bordered',
        name: 'Full Width Bordered',
        description: 'Professional bordered cards with subtle styling',
        preview: '┌●─────────┐\n│         │\n└─────────┘',
        config: {
            testimonialLayout: 'full-width-bordered'
        }
    },
];

const personalBrandingWidgetLayouts = [
    {
        id: 'glass-card',
        name: 'Glass Card Stack',
        description: 'Gestapelte transparente Karten mit Tiefeneffekt',
        preview: '🪟',
        config: {
            containerLayout: 'glass-card'
        }
    },
    {
        id: 'floating-island',
        name: 'Floating Island',
        description: 'Schwebender Container mit starken Schatten',
        preview: '🏝️',
        config: {
            containerLayout: 'floating-island'
        }
    },
    {
        id: 'magazine-cutout',
        name: 'Magazine Cutout',
        description: 'Asymmetrisches Magazin-Design',
        preview: '📰',
        config: {
            containerLayout: 'magazine-cutout'
        }
    },
    {
        id: 'neon-glow',
        name: 'Neon Glow',
        description: 'Leuchtender Neon-Rahmen (dunkler Hintergrund)',
        preview: '⚡',
        config: {
            containerLayout: 'neon-glow'
        }
    },
    {
        id: 'origami-fold',
        name: 'Origami Fold',
        description: '3D gefaltetes Papier-Design',
        preview: '📄',
        config: {
            containerLayout: 'origami-fold'
        }
    },
    {
        id: 'vintage-card',
        name: 'Vintage Card',
        description: 'Retro-Karte mit warmen Schatten und Textur',
        preview: '📜',
        config: {
            containerLayout: 'vintage-card'
        }
    },
    {
        id: 'minimal-border',
        name: 'Minimal Border',
        description: 'Clean Design mit elegantem Rahmen',
        preview: '⬜',
        config: {
            containerLayout: 'minimal-border'
        }
    },
    {
        id: 'accordion',
        name: 'Accordion',
        description: 'Aufklappbare Sektionen',
        preview: '🪗',
        config: {
            containerLayout: 'accordion'
        }
    }
];

const methodologyWidgetLayouts = [
    {
        id: 'classic-methodology',
        name: 'Classic Methodology',
        description: 'Text left, image right, horizontal steps',
        preview: '▐●\n123',
        icon: '/img/layouts/methodology-classic.svg',
        config: {
            topDirection: 'row',
            topImagePosition: 'right',
            topTextAlign: 'left',
            stepsDirection: 'row',
            stepsAlignment: 'left',
            imageSize: 'normal'
        }
    },
    {
        id: 'image-top-centered',
        name: 'Image Top Centered',
        description: 'Image on top, centered text, centered steps',
        preview: ' ● \n▐▐▐\n123',
        icon: '/img/layouts/methodology-centered.svg',
        config: {
            topDirection: 'column',
            topImagePosition: 'top',
            topTextAlign: 'center',
            stepsDirection: 'row',
            stepsAlignment: 'center',
            imageSize: 'large'
        }
    },
    {
        id: 'steps-vertical',
        name: 'Vertical Steps',
        description: 'Classic top layout, vertical step layout',
        preview: '▐●\n1\n2\n3',
        icon: '/img/layouts/methodology-vertical.svg',
        config: {
            topDirection: 'row',
            topImagePosition: 'right',
            topTextAlign: 'left',
            stepsDirection: 'column',
            stepsAlignment: 'left',
            imageSize: 'normal'
        }
    },
    {
        id: 'minimal-text-focus',
        name: 'Text Focus',
        description: 'Text-only focused layout, no images',
        preview: '▐▐▐\n123',
        icon: '/img/layouts/methodology-minimal.svg',
        config: {
            topDirection: 'column',
            topImagePosition: 'hidden',
            topTextAlign: 'center',
            stepsDirection: 'row',
            stepsAlignment: 'center',
            imageSize: 'hidden'
        }
    }
];

const supremeTestimonialLayouts = [
    {
        id: 'testimonial-cards',
        name: 'Testimonial Cards',
        description: 'Cards with avatars below quote',
        preview: '💬\n●●●',
        config: {
            displayType: 'cards',
            showCards: true,
            showNames: true,
            showAvatars: true,
            showInfo: true,
            textPosition: 'center'
        }
    },
    {
        id: 'simple-names-bottom',
        name: 'Simple Names',
        description: 'Quote with names below',
        preview: '💬\n📝📝',
        config: {
            displayType: 'simple-names',
            showCards: false,
            showNames: true,
            showAvatars: false,
            showInfo: true,
            textPosition: 'bottom'
        }
    },
    {
        id: 'quote-only',
        name: 'Quote Only',
        description: 'Just the quote, no attribution',
        preview: '💬💬💬',
        config: {
            displayType: 'quote-only',
            showCards: false,
            showNames: false,
            showAvatars: false,
            showInfo: false,
            textPosition: 'center'
        }
    },
    {
        id: 'minimal-attribution',
        name: 'Minimal Attribution',
        description: 'Quote with small name below',
        preview: '💬\n—Name',
        config: {
            displayType: 'minimal',
            showCards: false,
            showNames: true,
            showAvatars: false,
            showInfo: false,
            textPosition: 'bottom-minimal'
        }
    },
    {
        id: 'side-by-side',
        name: 'Side by Side',
        description: 'Quote left, attribution right',
        preview: '💬|👤',
        config: {
            displayType: 'side-by-side',
            showCards: false,
            showNames: true,
            showAvatars: true,
            showInfo: true,
            textPosition: 'side'
        }
    },
    {
        id: 'inline-below-quote',
        name: 'Inline Below Quote',
        description: 'Avatar & info directly under quote',
        preview: '💬\n●📝',
        config: {
            displayType: 'inline-below',
            showCards: false,
            showNames: true,
            showAvatars: true,
            showInfo: true,
            textPosition: 'inline-below'
        }
    },
    {
        id: 'avatar-carousel',
        name: 'Avatar Carousel',
        description: 'Large avatars as navigation',
        preview: '💬\n●●●',
        config: {
            displayType: 'avatar-carousel',
            showCards: false,
            showNames: true,
            showAvatars: true,
            showInfo: false,
            textPosition: 'carousel'
        }
    },
    {
        id: 'single-avatar-focus',
        name: 'Single Avatar Focus',
        description: 'One large avatar with name',
        preview: '💬\n●\nName',
        config: {
            displayType: 'single-avatar',
            showCards: false,
            showNames: true,
            showAvatars: true,
            showInfo: false,
            textPosition: 'single-focus'
        }
    }
];

const simplicisticHeaderLayouts = [
    {
        id: 'centered-classic',
        name: 'Centered Classic',
        description: 'Centered layout with large title',
        preview: '●\n▐\n□',
        config: {
            iconPosition: 'top',
            textAlign: 'center',
            contentDirection: 'column',
            centerLayout: true
        }
    },
    {
        id: 'icon-left-text-right',
        name: 'Icon Left',
        description: 'Icon left, text right',
        preview: '●▐',
        config: {
            iconPosition: 'left',
            textAlign: 'left',
            contentDirection: 'row'
        }
    }
];

const videoTeaserLayouts = [
    {
        id: 'classic-video-right',
        name: 'Classic Video Right',
        description: 'Text left, video right',
        preview: '▐📹',
        config: {
            videoPosition: 'right',
            textAlign: 'left',
            videoSize: 'medium',
            contentDirection: 'row',
            mobileStack: true
        }
    },
    {
        id: 'video-left',
        name: 'Video Left',
        description: 'Video left, text right',
        preview: '📹▐',
        config: {
            videoPosition: 'left',
            textAlign: 'left',
            videoSize: 'medium',
            contentDirection: 'row-reverse',
            mobileStack: true
        }
    },
    {
        id: 'video-dominant',
        name: 'Video Dominant',
        description: 'Large video, compact text',
        preview: '📹📹▐',
        config: {
            videoPosition: 'right',
            textAlign: 'left',
            videoSize: 'large',
            contentDirection: 'row',
            mobileStack: true
        }
    },
    {
        id: 'video-top-centered',
        name: 'Video Top Centered',
        description: 'Video on top, centered text',
        preview: '📹\n▐',
        config: {
            videoPosition: 'top',
            textAlign: 'center',
            videoSize: 'medium',
            contentDirection: 'column',
            mobileStack: false
        }
    },
    {
        id: 'mixed-centered',
        name: 'Mixed Centered',
        description: 'Text → Video → Button',
        preview: '▐\n📹\n🔲',
        config: {
            videoPosition: 'middle',
            textAlign: 'center',
            videoSize: 'large',
            contentDirection: 'column',
            mobileStack: false,
            customOrder: true
        }
    }
];

const spiritualTestimonialLayouts = [
    {
        id: 'classic-3-columns',
        name: 'Classic 3 Columns',
        description: 'Title top right, 3 equal columns',
        preview: '▐▐▐\n▐▐▐',
        config: {
            titlePosition: 'top-right',
            columnsDesktop: 3,
            columnsTablet: 2,
            columnsMobile: 1,
            titleAlignment: 'right',
            contentAlignment: 'top',
            titleSize: 48
        }
    },
    {
        id: 'title-center-3-cols',
        name: 'Centered Title',
        description: 'Title centered, 3 columns',
        preview: '▐▐▐\n▐▐▐',
        config: {
            titlePosition: 'top-center',
            columnsDesktop: 3,
            columnsTablet: 2,
            columnsMobile: 1,
            titleAlignment: 'center',
            contentAlignment: 'top',
            titleSize: 42
        }
    },
    {
        id: 'masonry-style',
        name: 'Masonry Style',
        description: 'Organic column heights',
        preview: '▐▐▐\n▌▐▌',
        config: {
            titlePosition: 'top-right',
            columnsDesktop: 3,
            columnsTablet: 2,
            columnsMobile: 1,
            titleAlignment: 'right',
            contentAlignment: 'top',
            enableMasonry: true,
            titleSize: 48
        }
    },
    {
        id: 'wide-2-columns',
        name: 'Wide 2 Columns',
        description: 'Spacious 2 column layout',
        preview: '▐▐\n▐▐',
        config: {
            titlePosition: 'top-center',
            columnsDesktop: 2,
            columnsTablet: 2,
            columnsMobile: 1,
            titleAlignment: 'center',
            contentAlignment: 'top',
            columnSpacing: 60,
            titleSize: 52
        }
    },
    {
        id: 'single-column-elegant',
        name: 'Single Column',
        description: 'Elegant single column',
        preview: '▐\n▐\n▐',
        config: {
            titlePosition: 'top-center',
            columnsDesktop: 1,
            columnsTablet: 1,
            columnsMobile: 1,
            titleAlignment: 'center',
            contentAlignment: 'center',
            testimonialItemSpacing: 50,
            titleSize: 56
        }
    },
    {
        id: 'magazine-style',
        name: 'Magazine Style',
        description: 'Title left, content right',
        preview: '▐●●\n▐●●',
        config: {
            titlePosition: 'left-side',
            columnsDesktop: 2,
            columnsTablet: 2,
            columnsMobile: 1,
            titleAlignment: 'left',
            contentAlignment: 'top',
            titleSize: 56,
            showTitleInSidebar: true
        }
    }
];

const simplicisticServicesLayouts = [
    {
        id: 'classic-grid',
        name: 'Classic Grid',
        description: 'Professional grid layout',
        preview: '●●\n●●',
        config: {
            serviceLayout: 'classic-grid',
            servicesPerRow: 2,
            serviceShadow: true,
            serviceBorderRadius: 16
        }
    },
    {
        id: 'neon-glow',
        name: 'Neon Glow',
        description: 'Futuristic neon glow effects',
        preview: '◉◉\n◉◉',
        config: {
            serviceLayout: 'neon-glow',
            servicesPerRow: 2,
            serviceShadow: true,
            serviceBorderRadius: 20
        }
    },
    {
        id: 'luxury-cards',
        name: 'Luxury Cards',
        description: 'Premium golden accents',
        preview: '◇◇\n◇◇',
        config: {
            serviceLayout: 'luxury-cards',
            servicesPerRow: 2,
            serviceShadow: true,
            serviceBorderRadius: 20
        }
    },
    {
        id: 'glass-panels',
        name: 'Glass Panels',
        description: 'Modern glassmorphism',
        preview: '▢▢▢\n▢▢▢',
        config: {
            serviceLayout: 'glass-panels',
            servicesPerRow: 3,
            serviceShadow: true,
            serviceBorderRadius: 18
        }
    },
    {
        id: 'gradient-cards',
        name: 'Gradient Cards',
        description: 'Colorful gradient backgrounds',
        preview: '🌈🌈\n🌈🌈',
        config: {
            serviceLayout: 'gradient-cards',
            servicesPerRow: 2,
            serviceShadow: true,
            serviceBorderRadius: 24
        }
    },
    {
        id: 'cyber-tech',
        name: 'Cyber Tech',
        description: 'High-tech cyberpunk style',
        preview: '▣▣\n▣▣',
        config: {
            serviceLayout: 'cyber-tech',
            servicesPerRow: 2,
            serviceShadow: true,
            serviceBorderRadius: 8
        }
    },
    {
        id: 'floating-cards',
        name: 'Floating Cards',
        description: 'Elevated floating effect',
        preview: '◯◯◯\n◯◯◯',
        config: {
            serviceLayout: 'floating-cards',
            servicesPerRow: 3,
            serviceShadow: true,
            serviceBorderRadius: 16
        }
    },
    {
        id: 'minimal-clean',
        name: 'Minimal Clean',
        description: 'Ultra clean minimal design',
        preview: '□□□□\n□□□□',
        config: {
            serviceLayout: 'minimal-clean',
            servicesPerRow: 4,
            serviceShadow: false,
            serviceBorderRadius: 8
        }
    }
];

const bulletPointsWidgetLayouts = [
    {
        id: 'icon-left',
        name: 'Icon Left',
        description: 'Icons on the left, text on the right',
        preview: '●▐\n●▐\n●▐',
        config: {
            bulletLayout: 'icon-left',
            bulletPointsPerRow: 2,
            bulletPointAlignment: 'left'
        }
    },
    {
        id: 'icon-top',
        name: 'Icon Top',
        description: 'Icons on top, text below, centered',
        preview: '●●\n▐▐\n▐▐',
        config: {
            bulletLayout: 'icon-top',
            bulletPointsPerRow: 2,
            bulletPointAlignment: 'center'
        }
    },
    {
        id: 'numbered',
        name: 'Numbered',
        description: 'Numbered list without icons',
        preview: '1▐\n2▐\n3▐',
        config: {
            bulletLayout: 'numbered',
            bulletPointsPerRow: 1,
            bulletPointAlignment: 'left'
        }
    },
    {
        id: 'minimal',
        name: 'Minimal',
        description: 'Simple bullet points, text focused',
        preview: '•▐\n•▐\n•▐',
        config: {
            bulletLayout: 'minimal',
            bulletPointsPerRow: 1,
            bulletPointAlignment: 'left'
        }
    },
    {
        id: 'clean-icon',
        name: 'Clean Icon',
        description: 'Icons without background, clean design',
        preview: '○▐\n○▐\n○▐',
        config: {
            bulletLayout: 'clean-icon',
            bulletPointsPerRow: 2,
            bulletPointAlignment: 'left'
        }
    },
    {
        id: 'clean-icon-single',
        name: 'Clean Icon Single',
        description: 'Icons without background, single column',
        preview: '○▐\n○▐\n○▐',
        config: {
            bulletLayout: 'clean-icon',
            bulletPointsPerRow: 1,
            bulletPointAlignment: 'left'
        }
    }
];

const comparisonWidgetLayouts = [
    {
        id: 'text-left-images-right',
        name: 'Text Left, Images Right',
        description: 'Simple layout with text on left, images on right',
        preview: '▐●●',
        config: {
            comparisonLayout: 'text-left-images-right',
            textAlignment: 'left',
            imageAlignment: 'center',
            imageOverlap: 0,
            contentSpacing: 40,
            mobileLayout: 'stacked'
        }
    },
    {
        id: 'text-top-images-bottom',
        name: 'Text Top, Images Bottom',
        description: 'Text above, images below',
        preview: '▐▐▐\n●●●',
        config: {
            comparisonLayout: 'text-top-images-bottom',
            textAlignment: 'center',
            imageAlignment: 'center',
            imageOverlap: 0,
            contentSpacing: 30,
            mobileLayout: 'stacked'
        }
    },
    {
        id: 'images-top-text-bottom',
        name: 'Images Top, Text Bottom',
        description: 'Images above, text below',
        preview: '●●●\n▐▐▐',
        config: {
            comparisonLayout: 'images-top-text-bottom',
            textAlignment: 'center',
            imageAlignment: 'center',
            imageOverlap: 0,
            contentSpacing: 30,
            mobileLayout: 'stacked'
        }
    }
];

const fancyFooterLayouts = [
    {
        id: 'corporate-layout',
        name: 'Corporate',
        description: 'Full footer: Logo, Contact, Navigation, Social + Bottom',
        preview: '●📞▐▐\n────────',
        config: {
            showLogo: true,
            showContactInfo: true,
            showNavigation: true,
            showSocialLinks: true,
            showBottomBar: true,
            direction: 'row',
            alignment: 'flex-start',
            logoPosition: 'left',
            columnsPerRow: 4,
            spacing: 'normal',
            style: 'professional'
        }
    },
    {
        id: 'modern-layout',
        name: 'Modern',
        description: 'Logo centered, Navigation + Social, no Contact',
        preview: '●●●\n▐▐▐\n────',
        config: {
            showLogo: true,
            showContactInfo: false,
            showNavigation: true,
            showSocialLinks: true,
            showBottomBar: true,
            direction: 'column',
            alignment: 'center',
            logoPosition: 'center',
            columnsPerRow: 3,
            spacing: 'wide',
            style: 'modern'
        }
    },
    {
        id: 'minimal-layout',
        name: 'Minimal',
        description: 'Only bottom bar with copyright & legal links',
        preview: '────────',
        config: {
            showLogo: false,
            showContactInfo: false,
            showNavigation: false,
            showSocialLinks: false,
            showBottomBar: true,
            direction: 'row',
            alignment: 'center',
            logoPosition: 'center',
            columnsPerRow: 1,
            spacing: 'compact',
            style: 'minimal'
        }
    },
    {
        id: 'creative-layout',
        name: 'Creative',
        description: 'Logo + Contact + Social, no Navigation or Bottom',
        preview: '●📞\n●●●',
        config: {
            showLogo: true,
            showContactInfo: true,
            showNavigation: false,
            showSocialLinks: true,
            showBottomBar: false,
            direction: 'column',
            alignment: 'center',
            logoPosition: 'center',
            columnsPerRow: 2,
            spacing: 'creative',
            style: 'creative'
        }
    }
];

const achievementsBannerLayouts = [
    {
        id: 'classic-horizontal',
        name: 'Classic Horizontal',
        description: 'Centered achievements in a row (responsive: mobile stacks vertically)',
        preview: '●●●',
        config: {
            containerDirection: 'row',
            containerJustify: 'center',
            containerAlign: 'center',
            spacing: 80,
            showSeparator: true,      // ✅ Separator einschalten
            showIcons: true           // ✅ Icons einschalten
        }
    },
    {
        id: 'minimal-text-only',
        name: 'Minimal Text Only',
        description: 'Clean layout with only numbers and text, no separators or icons',
        preview: '123',
        config: {
            containerDirection: 'row',
            containerJustify: 'center',
            containerAlign: 'center',
            spacing: 60,
            showSeparator: false,
            showIcons: false
        }
    },
    {
        id: 'framed-cards',
        name: 'Framed Cards',
        description: 'Elegant achievement cards with classic outline frames',
        preview: '[1][2][3]',
        config: {
            containerDirection: 'row',
            containerJustify: 'center',
            containerAlign: 'center',
            spacing: 40,
            showSeparator: false,
            showIcons: true,
            showFrames: true,
            framePadding: 24,
            frameBorderRadius: 12
        }
    }
];

// ✅ SPIRITUAL FEATURE BANNER LAYOUTS - NEW LAYOUT SYSTEM 2025
const spiritualFeatureBannerLayouts = [
    {
        id: 'classic-center',
        name: 'Classic Center',
        description: 'Features around center image',
        preview: '◐◑',
        icon: '/img/layouts/classic-center.svg',
        config: {
            direction: 'row',
            centerImage: true,
            featuresLayout: 'sides',
            textAlign: 'left',
            imagePosition: 'center',
            overlayMode: false,
            mobileStack: true
        }
    },
    {
        id: 'image-top-vertical',
        name: 'Image Top Vertical',
        description: 'Image on top, features below',
        preview: '▓\n▐▐',
        icon: '/img/layouts/image-top-vertical.svg',
        config: {
            direction: 'column',
            centerImage: true,
            featuresLayout: 'vertical',
            textAlign: 'center',
            imagePosition: 'top',
            overlayMode: false,
            mobileStack: true
        }
    },
    {
        id: 'compact-features',
        name: 'Compact Features',
        description: 'Compact layout with smaller spacing',
        preview: '◐◑',
        icon: '/img/layouts/compact-features.svg',
        config: {
            direction: 'row',
            centerImage: true,
            featuresLayout: 'sides',
            textAlign: 'left',
            imagePosition: 'center',
            overlayMode: false,
            mobileStack: true,
            compact: true
        }
    }
];

function LayoutSelector({ 
    widgetType = 'heroHeader',
    selectedLayout = 'classic-split',
    onLayoutChange,
    showPreview = true
}) {
    
    const layouts = widgetType === 'heroHeader' ? heroHeaderLayouts : 
                   widgetType === 'hiWidget' ? hiWidgetLayouts :
                   widgetType === 'videoTeaser' ? videoTeaserLayouts :
                   widgetType === 'simplicisticHeader' ? simplicisticHeaderLayouts :
                   widgetType === 'supremeTestimonial' ? supremeTestimonialLayouts :
                   widgetType === 'methodologyWidget' ? methodologyWidgetLayouts :
                   widgetType === 'personalBrandingWidget' ? personalBrandingWidgetLayouts :
                   widgetType === 'simplicisticTestimonial' ? simplicisticTestimonialLayouts :
                   widgetType === 'simplicisticServices' ? simplicisticServicesLayouts :
                   widgetType === 'bulletPointsWidget' ? bulletPointsWidgetLayouts :
                   widgetType === 'comparisonWidget' ? comparisonWidgetLayouts :
                   widgetType === 'spiritualTestimonial' ? spiritualTestimonialLayouts :
                   widgetType === 'achievementsBanner' ? achievementsBannerLayouts :
                   widgetType === 'fancyFooter' ? fancyFooterLayouts :
                   widgetType === 'spiritualFeatureBanner' ? spiritualFeatureBannerLayouts : [];
    
    const handleLayoutSelect = (layoutId) => {
        const layout = layouts.find(l => l.id === layoutId);
        if (layout && onLayoutChange) {
            onLayoutChange(layoutId, layout.config);
        }
    };

    return (
        <div className="layout-selector">
            <div className="layout-selector-header">
                <h3 className="layout-selector-title">
                    <img src="/img/layouts.svg" alt="" className="layout-selector-icon" />
                    Layout Variations
                </h3>
                <p className="layout-selector-description">
                    Choose how your content is arranged
                </p>
            </div>

            <div className="layout-options-grid">
                {layouts.map((layout) => (
                    <div
                        key={layout.id}
                        className={`layout-option ${selectedLayout === layout.id ? 'selected' : ''}`}
                        onClick={() => handleLayoutSelect(layout.id)}
                        title={layout.description}
                    >
                        {/* Mini Structure Preview */}
                        <div className="layout-preview">
                            <div className={`layout-mini-preview ${layout.id}`}>
                                {layout.id === 'classic-split' && (
                                    <>
                                        <div className="mini-text-section"></div>
                                        <div className="mini-image-section"></div>
                                    </>
                                )}
                                {layout.id === 'full-width-overlay' && (
                                    <div className="mini-overlay-section">
                                        <div className="mini-overlay-content"></div>
                                    </div>
                                )}
                                
                                {/* HiWidget Layouts */}
                                {layout.id === 'classic-profile' && (
                                    <>
                                        <div className="mini-profile-image"></div>
                                        <div className="mini-profile-text"></div>
                                    </>
                                )}
                                {layout.id === 'text-focus' && (
                                    <>
                                        <div className="mini-profile-image small"></div>
                                        <div className="mini-profile-text wide"></div>
                                    </>
                                )}
                                {layout.id === 'image-focus' && (
                                    <>
                                        <div className="mini-profile-image large"></div>
                                        <div className="mini-profile-text"></div>
                                    </>
                                )}
                                {layout.id === 'centered-profile' && (
                                    <div className="mini-profile-centered">
                                        <div className="mini-profile-image-center"></div>
                                        <div className="mini-profile-text-center"></div>
                                    </div>
                                )}
                                {layout.id === 'reverse-profile' && (
                                    <>
                                        <div className="mini-profile-text"></div>
                                        <div className="mini-profile-image"></div>
                                    </>
                                )}
                                {layout.id === 'compact-inline' && (
                                    <>
                                        <div className="mini-profile-image tiny"></div>
                                        <div className="mini-profile-text compact"></div>
                                    </>
                                )}
                                {(layout.id === 'text-only-center' || layout.id === 'text-only-left' || layout.id === 'text-only-right') && (
                                    <div className="mini-text-only">
                                        <div className="mini-text-only-content"></div>
                                    </div>
                                )}
                                {layout.id === 'full-height-left' && (
                                    <>
                                        <div className="mini-full-height-image"></div>
                                        <div className="mini-profile-text"></div>
                                    </>
                                )}
                                {layout.id === 'full-height-right' && (
                                    <>
                                        <div className="mini-profile-text"></div>
                                        <div className="mini-full-height-image"></div>
                                    </>
                                )}
                                {layout.id === 'image-top-full' && (
                                    <div className="mini-image-top-full">
                                        <div className="mini-full-width-image"></div>
                                        <div className="mini-profile-text-bottom"></div>
                                    </div>
                                )}

                                {/* VideoTeaser Layouts */}
                                {layout.id === 'classic-video-right' && (
                                    <>
                                        <div className="mini-videoteaser-text"></div>
                                        <div className="mini-videoteaser-player"></div>
                                    </>
                                )}
                                {layout.id === 'video-left' && (
                                    <>
                                        <div className="mini-videoteaser-player left-position"></div>
                                        <div className="mini-videoteaser-text right-position"></div>
                                    </>
                                )}
                                {layout.id === 'video-dominant' && (
                                    <>
                                        <div className="mini-videoteaser-text narrow"></div>
                                        <div className="mini-videoteaser-player large"></div>
                                    </>
                                )}
                                {layout.id === 'video-top-centered' && (
                                    <div className="mini-videoteaser-column-spaced">
                                        <div className="mini-videoteaser-player centered large-preview"></div>
                                        <div className="mini-videoteaser-text centered"></div>
                                    </div>
                                )}
                                {layout.id === 'full-width-video' && (
                                    <div className="mini-videoteaser-full-width-spaced">
                                        <div className="mini-videoteaser-player full-width large-preview"></div>
                                        <div className="mini-videoteaser-text centered small"></div>
                                    </div>
                                )}

                                {/* SimplisticHeader Layouts */}
                                {layout.id === 'centered-classic' && (
                                    <div className="mini-simplicistic-centered">
                                        <div className="mini-simplicistic-icon centered"></div>
                                        <div className="mini-simplicistic-text centered large-title"></div>
                                        <div className="mini-simplicistic-button centered"></div>
                                    </div>
                                )}
                                {layout.id === 'icon-left-text-right' && (
                                    <>
                                        <div className="mini-simplicistic-icon"></div>
                                        <div className="mini-simplicistic-text"></div>
                                    </>
                                )}
                                {layout.id === 'icon-right-text-left' && (
                                    <>
                                        <div className="mini-simplicistic-text"></div>
                                        <div className="mini-simplicistic-icon"></div>
                                    </>
                                )}

                                {/* MethodologyWidget Layouts */}
                                {layout.id === 'classic-methodology' && (
                                    <div className="mini-methodology-layout">
                                        <div className="mini-methodology-top">
                                            <div className="mini-methodology-text"></div>
                                            <div className="mini-methodology-image"></div>
                                        </div>
                                        <div className="mini-methodology-steps horizontal">
                                            <div className="mini-step">1</div>
                                            <div className="mini-step">2</div>
                                            <div className="mini-step">3</div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'image-top-centered' && (
                                    <div className="mini-methodology-layout centered">
                                        <div className="mini-methodology-image large centered"></div>
                                        <div className="mini-methodology-text centered"></div>
                                        <div className="mini-methodology-steps horizontal centered">
                                            <div className="mini-step">1</div>
                                            <div className="mini-step">2</div>
                                            <div className="mini-step">3</div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'steps-vertical' && (
                                    <div className="mini-methodology-layout">
                                        <div className="mini-methodology-top">
                                            <div className="mini-methodology-text"></div>
                                            <div className="mini-methodology-image"></div>
                                        </div>
                                        <div className="mini-methodology-steps vertical">
                                            <div className="mini-step">1</div>
                                            <div className="mini-step">2</div>
                                            <div className="mini-step">3</div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'minimal-text-focus' && (
                                    <div className="mini-methodology-layout text-only">
                                        <div className="mini-methodology-text centered large"></div>
                                        <div className="mini-methodology-steps horizontal centered">
                                            <div className="mini-step">1</div>
                                            <div className="mini-step">2</div>
                                            <div className="mini-step">3</div>
                                        </div>
                                    </div>
                                )}

                                {/* SupremeTestimonial Layouts */}
                                {layout.id === 'testimonial-cards' && (
                                    <div className="mini-testimonial-column">
                                        <div className="mini-testimonial-quote"></div>
                                        <div className="mini-testimonial-cards">
                                            <div className="mini-testimonial-card"></div>
                                            <div className="mini-testimonial-card active"></div>
                                            <div className="mini-testimonial-card"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'simple-names-bottom' && (
                                    <div className="mini-testimonial-column">
                                        <div className="mini-testimonial-quote large"></div>
                                        <div className="mini-testimonial-names">
                                            <div className="mini-testimonial-name"></div>
                                            <div className="mini-testimonial-name"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'quote-only' && (
                                    <div className="mini-testimonial-quote-only"></div>
                                )}
                                {layout.id === 'minimal-attribution' && (
                                    <div className="mini-testimonial-column">
                                        <div className="mini-testimonial-quote large"></div>
                                        <div className="mini-testimonial-minimal-name"></div>
                                    </div>
                                )}
                                {layout.id === 'side-by-side' && (
                                    <>
                                        <div className="mini-testimonial-quote side"></div>
                                        <div className="mini-testimonial-profile"></div>
                                    </>
                                )}
                                {layout.id === 'inline-below-quote' && (
                                    <div className="mini-testimonial-inline-below">
                                        <div className="mini-testimonial-quote large"></div>
                                        <div className="mini-testimonial-inline-attribution">
                                            <div className="mini-testimonial-avatar-tiny"></div>
                                            <div className="mini-testimonial-inline-text"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'avatar-carousel' && (
                                    <div className="mini-testimonial-carousel">
                                        <div className="mini-testimonial-quote large"></div>
                                        <div className="mini-testimonial-avatar-row">
                                            <div className="mini-testimonial-avatar-carousel"></div>
                                            <div className="mini-testimonial-avatar-carousel active"></div>
                                            <div className="mini-testimonial-avatar-carousel"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'single-avatar-focus' && (
                                    <div className="mini-testimonial-single-focus">
                                        <div className="mini-testimonial-quote large"></div>
                                        <div className="mini-testimonial-single-avatar-large"></div>
                                        <div className="mini-testimonial-single-name"></div>
                                    </div>
                                )}

                                {/* PersonalBrandingWidget Layouts */}
                                {layout.id === 'glass-card' && (
                                    <div className="mini-personal-branding glass-card">
                                        <div className="mini-pb-image"></div>
                                        <div className="mini-pb-container glass-effect">
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'floating-island' && (
                                    <div className="mini-personal-branding floating">
                                        <div className="mini-pb-image"></div>
                                        <div className="mini-pb-container floating-effect">
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'magazine-cutout' && (
                                    <div className="mini-personal-branding magazine">
                                        <div className="mini-pb-image"></div>
                                        <div className="mini-pb-container magazine-effect">
                                            <div className="mini-pb-accent-line"></div>
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'neon-glow' && (
                                    <div className="mini-personal-branding neon">
                                        <div className="mini-pb-image"></div>
                                        <div className="mini-pb-container neon-effect">
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'vintage-card' && (
                                    <div className="mini-personal-branding vintage">
                                        <div className="mini-pb-image"></div>
                                        <div className="mini-pb-container vintage-effect">
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'minimal-border' && (
                                    <div className="mini-personal-branding minimal">
                                        <div className="mini-pb-image"></div>
                                        <div className="mini-pb-container minimal-effect">
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(layout.id === 'origami-fold' || layout.id === 'accordion') && (
                                    <div className="mini-personal-branding standard">
                                        <div className="mini-pb-image"></div>
                                        <div className={`mini-pb-container ${layout.id === 'origami-fold' ? 'origami-effect' : 'accordion-effect'}`}>
                                            <div className="mini-pb-title"></div>
                                            <div className="mini-pb-bullets">
                                                <div className="mini-pb-bullet"></div>
                                                <div className="mini-pb-bullet"></div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {layout.id === 'centered-column' && (
                                    <div className="mini-video-layout centered-column">
                                        <div className="mini-video-text"></div>
                                        <div className="mini-video-player"></div>
                                        <div className="mini-video-button"></div>
                                    </div>
                                )}
                                {layout.id === 'split-left' && (
                                    <div className="mini-video-layout split">
                                        <div className="mini-video-player left"></div>
                                        <div className="mini-video-content">
                                            <div className="mini-video-text"></div>
                                            <div className="mini-video-text short"></div>
                                            <div className="mini-video-button"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'split-right' && (
                                    <div className="mini-video-layout split">
                                        <div className="mini-video-content">
                                            <div className="mini-video-text"></div>
                                            <div className="mini-video-text short"></div>
                                            <div className="mini-video-button"></div>
                                        </div>
                                        <div className="mini-video-player right"></div>
                                    </div>
                                )}
                                {layout.id === 'cinema-mode' && (
                                    <div className="mini-video-layout cinema">
                                        <div className="mini-video-player cinema-large"></div>
                                        <div className="mini-video-text-minimal"></div>
                                    </div>
                                )}

                                {/* SimplisticTestimonial Layouts */}
                                {layout.id === 'classic-grid' && (
                                    <div className="mini-testimonial-layout grid">
                                        <div className="mini-testimonial-card premium"></div>
                                        <div className="mini-testimonial-card premium"></div>
                                        <div className="mini-testimonial-card premium"></div>
                                    </div>
                                )}
                                {layout.id === 'masonry-flow' && (
                                    <div className="mini-testimonial-layout masonry">
                                        <div className="mini-testimonial-column">
                                            <div className="mini-testimonial-card tall organic"></div>
                                            <div className="mini-testimonial-card short organic"></div>
                                        </div>
                                        <div className="mini-testimonial-column">
                                            <div className="mini-testimonial-card short organic"></div>
                                            <div className="mini-testimonial-card tall organic"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'luxury-cards' && (
                                    <div className="mini-testimonial-layout grid">
                                        <div className="mini-testimonial-card luxury"></div>
                                        <div className="mini-testimonial-card luxury"></div>
                                        <div className="mini-testimonial-card luxury"></div>
                                    </div>
                                )}
                                {layout.id === 'glass-panels' && (
                                    <div className="mini-testimonial-layout grid">
                                        <div className="mini-testimonial-card glass"></div>
                                        <div className="mini-testimonial-card glass"></div>
                                        <div className="mini-testimonial-card glass"></div>
                                    </div>
                                )}
                                {layout.id === 'paper-cards' && (
                                    <div className="mini-testimonial-layout grid">
                                        <div className="mini-testimonial-card paper"></div>
                                        <div className="mini-testimonial-card paper"></div>
                                        <div className="mini-testimonial-card paper"></div>
                                    </div>
                                )}

                                {/* Bullet Points Widget Layouts */}
                                {layout.id === 'icon-left' && (
                                    <div className="mini-bullet-layout icon-left">
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-icon"></div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-icon"></div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'icon-top' && (
                                    <div className="mini-bullet-layout icon-top">
                                        <div className="mini-bullet-item vertical">
                                            <div className="mini-bullet-icon"></div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                        <div className="mini-bullet-item vertical">
                                            <div className="mini-bullet-icon"></div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'numbered' && (
                                    <div className="mini-bullet-layout numbered">
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-number">1</div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-number">2</div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                    </div>
                                )}
                                {layout.id === 'minimal' && (
                                    <div className="mini-bullet-layout minimal">
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-dot">•</div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-dot">•</div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                    </div>
                                )}
                                {(layout.id === 'clean-icon' || layout.id === 'clean-icon-single') && (
                                    <div className="mini-bullet-layout clean-icon">
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-icon clean"></div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                        <div className="mini-bullet-item">
                                            <div className="mini-bullet-icon clean"></div>
                                            <div className="mini-bullet-text"></div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Info */}
                        <div className="layout-info">
                            <h4 className="layout-name">{layout.name}</h4>
                            <p className="layout-description">{layout.description}</p>
                        </div>

                        {/* Selected Indicator */}
                        {selectedLayout === layout.id && (
                            <div className="layout-selected-indicator">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path 
                                        d="M13.5 4.5L6 12L2.5 8.5" 
                                        stroke="currentColor" 
                                        strokeWidth="2" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        )}
                    </div>
                ))}
            </div>

        </div>
    );
}

export default LayoutSelector;
